import { MimaButton, MimaText, Modal } from '..';
import { adminStore, catalogStore } from '../../stores';

const LogoutModal = ({ closeModal }) => {
	const logout = () => {
		adminStore.setLoggedIn(false);
		adminStore.setToken('');
		catalogStore.setEditMode(false);
		closeModal();
	};

	return (
		<Modal closeModal={closeModal}>
			<MimaText variant="subtitle" mb={2}>
				Are you sure you <br /> want to log out?
			</MimaText>

			<div style={{ display: 'flex', gap: '2rem' }}>
				<MimaButton
					title="Yes"
					onClick={logout}
					width={18}
					titleColor="var(--color-white)"
					variant="regular"
				/>
				<MimaButton
					title="No"
					onClick={closeModal}
					buttonColor="var(--color-error)"
					titleColor="var(--color-white)"
					width={18}
					variant="regular"
				/>
			</div>
		</Modal>
	);
};

export default LogoutModal;
